import { Button, DatePicker, Popconfirm, Select, Space, Table, Tag, Typography } from 'antd';
import dayjs from 'dayjs';

const { Paragraph, Text } = Typography;

/*
 * Configuration de l'année scolaire. C'est ce qui remplace les valeurs autrefois écrites
 * dans le code : modifier ici suffit, aucun déploiement n'est nécessaire.
 */
const ConfigPanel = ({ codeOptions, config, dropConfig, platforms, running, saveConfig, savingConfig }) => {
  const defaultConfig = config.find(c => c.projet === '*');

  // Une ligne par plateforme connue, plus la ligne par défaut : on peut créer une surcharge
  // pour n'importe quelle plateforme sans passer par le code.
  const rows = [
    defaultConfig || { code: null, projet: '*', yearStart: null },
    ...platforms.map(p => {
      const override = config.find(c => c.projet === p.projet);
      return {
        code: override ? override.code : p.code,
        herite: !override,
        projet: p.projet,
        yearStart: override ? override.yearStart : p.rentree,
      };
    }),
  ];

  const columns = [
    {
      dataIndex: 'projet',
      key: 'projet',
      render: (projet, row) => (
        <Space>
          <Text strong>{projet === '*' ? '* (par défaut)' : projet}</Text>
          {row.herite && <Tag>hérité</Tag>}
        </Space>
      ),
      title: 'Plateforme',
    },
    {
      dataIndex: 'yearStart',
      key: 'yearStart',
      render: (yearStart, row) => (
        <DatePicker
          format="YYYY-MM-DD"
          onChange={value => saveConfig({ ...row, yearStart: value ? value.format('YYYY-MM-DD') : null })}
          value={yearStart ? dayjs(yearStart) : null}
        />
      ),
      title: 'Rentrée',
    },
    {
      dataIndex: 'code',
      key: 'code',
      render: (code, row) => (
        <Select
          allowClear
          showSearch
          loading={savingConfig === row.projet}
          onChange={value => saveConfig({ ...row, code: value ?? null })}
          options={codeOptions}
          placeholder="Aucun code"
          style={{ width: 300 }}
          value={code}
        />
      ),
      title: 'Code des nouveaux enseignants',
    },
    {
      key: 'actions',
      render: (_, row) =>
        row.projet !== '*' && !row.herite ? (
          <Popconfirm title="Revenir à la configuration par défaut ?" onConfirm={() => dropConfig(row.projet)}>
            <Button disabled={running} size="small" type="link">
              Retirer la surcharge
            </Button>
          </Popconfirm>
        ) : null,
      title: '',
    },
  ];

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Paragraph type="secondary">
        La date de rentrée sert de seuil pour « actif depuis la rentrée », et le code est celui que reçoit un enseignant à sa
        première connexion. La ligne <Text code>*</Text> s&apos;applique à toutes les plateformes ; une ligne au nom d&apos;une
        plateforme la surcharge — la Nouvelle-Calédonie, dont la rentrée est en janvier.
      </Paragraph>
      <Table columns={columns} dataSource={rows} pagination={false} rowKey="projet" size="small" />
    </Space>
  );
};

export default ConfigPanel;
